import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationsService } from "../services/notifications.service";
import { handleRejectError } from "../../../utils/api/api.utils";
import { formatNotificationData } from "../../../utils/notification.utils";

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const response = await notificationsService.getNotifications();
      if (response.success && response.data) {
        const items = response.data.items || [];
        const formattedItems = formatNotificationData(items);
        return {
          ...response.data,
          items: formattedItems,
        };
      }
      return rejectWithValue(
        response.message || "Failed to fetch notifications",
      );
    } catch (error: any) {
      return handleRejectError(rejectWithValue, error);
    }
  },
);

export const fetchUnreadCount = createAsyncThunk(
  "notifications/fetchUnreadCount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await notificationsService.getUnreadCount();
      if (response.success && response.data) {
        return response.data;
      }
      return rejectWithValue(
        response.message || "Failed to fetch unread count",
      );
    } catch (error: any) {
      return handleRejectError(rejectWithValue, error);
    }
  },
);

export const markNotificationRead = createAsyncThunk(
  "notifications/markRead",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await notificationsService.markAsRead(id);
      if (response.success) {
        return {
          id,
          unreadCountChanged: response.data?.unreadCountChanged ?? false,
        };
      }
      return rejectWithValue(
        response.message || "Failed to mark notification as read",
      );
    } catch (error: any) {
      return handleRejectError(rejectWithValue, error);
    }
  },
);

export const markAllNotificationsRead = createAsyncThunk(
  "notifications/markAllRead",
  async (_, { rejectWithValue }) => {
    try {
      const response = await notificationsService.markAllAsRead();
      if (response.success) {
        return true;
      }
      return rejectWithValue(
        response.message || "Failed to mark all notifications as read",
      );
    } catch (error: any) {
      return handleRejectError(rejectWithValue, error);
    }
  },
);
